// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useAppSelector } from 'app/hooks'
import { SystemTheme } from './types'

export const useUi = () => {
  const uiState = useAppSelector(({ ui }) => ui)
  return uiState
}

export const useDisplayTheme = () => {
  const theme = useAppSelector(({ ui }) => ui.displayTheme)
  return theme
}

export const useSysTheme = (): SystemTheme => {
  const theme = useDisplayTheme()
  return {
    ...sys,
    ...(theme === 'light' ? sys.light : sys.dark)
  }
}

export const useRefreshInfo = () => {
  const autoRefreshInfo = useAppSelector(({ ui }) => ui.refresh)
  return autoRefreshInfo
}

export const useLightboxInfo = () => {
  const lightboxInfo = useAppSelector(({ ui }) => ui.lightbox)
  return lightboxInfo
}

export const usePage = () => {
  const page = useAppSelector(({ ui }) => ui.page)
  return page
}

export const useDashboardViewLayout = () => {
  const dashboardViewLayout = useAppSelector(({ ui }) => ui.dashboardViewLayout)
  return dashboardViewLayout
}
